import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

import Breadcrumb from '../../component-library/breadcrumb';

const News = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const [activeSection, setActiveSection] = useState('announcements');
	const [breadcrumbData, setBreadcrumbData] = useState([
		{ name: 'Home', url: '/' },
		{ name: 'Latest News' },
	]);

	useEffect(() => {
		let newActiveSection = 'catalog';
		let newBreadcrumbData = [
			{ name: 'Home', url: '/' },
			{ name: 'Catalog' },
		];
		if (pathname.includes('announcements')) {
			newActiveSection = 'announcements';
			newBreadcrumbData = [{ name: 'Home', url: '/' }, { name: 'Latest News', url: '/news/announcements' }, { name: 'Announcements' }];
		}
		if (pathname.includes('provider-updates')) {
			newActiveSection = 'provider-updates';
			newBreadcrumbData = [{ name: 'Home', url: '/' }, { name: 'Latest News', url: '/news/announcements' }, { name: 'Provider Updates' }];
		}
		setBreadcrumbData(newBreadcrumbData);
		setActiveSection(newActiveSection);
	}, [pathname]);

	return (
		<>
			<Breadcrumb
				data={breadcrumbData}
			/>
			<div className="search__grid">
				<div className="left-navigation">
					<button
						className={`${activeSection === 'announcements' && 'is-active'}`}
						onClick={() => navigate('/news/announcements')}
						type="button"
					>
						Announcements
					</button>
					<button
						className={`${activeSection === 'provider-updates' && 'is-active'}`}
						onClick={() => navigate('/news/provider-updates')}
						type="button"
					>
						Provider Updates
					</button>
				</div>
				<Outlet />
			</div>
		</>
	);
};

export default News;
